import { render, staticRenderFns } from "./RegistrationPrompt.vue?vue&type=template&id=0b29e8a6&scoped=true"
import script from "./RegistrationPrompt.vue?vue&type=script&lang=js"
export * from "./RegistrationPrompt.vue?vue&type=script&lang=js"
import style0 from "./RegistrationPrompt.vue?vue&type=style&index=0&id=0b29e8a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b29e8a6",
  null
  
)

export default component.exports